import { render } from "./InterestSection.vue?vue&type=template&id=233347b1&scoped=true&ts=true"
import script from "./InterestSection.vue?vue&type=script&lang=ts"
export * from "./InterestSection.vue?vue&type=script&lang=ts"

import "./InterestSection.vue?vue&type=style&index=0&id=233347b1&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-233347b1"]])

export default __exports__